export const SINGLE = 1;
export const DORMITORY = 1;
export const DOUBLE = 2;
export const TWIN = 2;
export const TRIPLE = 3;
export const QUAD = 4;
export const FAMILY = 4;
